import { configureStore } from '@reduxjs/toolkit'

import authReducer from './slices/auth.slice'
import menuReducer from './slices/menu.slice'
import merchantsDataReducer from './slices/merchantsData.slice'
import paginationReducer from './slices/pagination.slice'
import settingsReducer from './slices/settings.slice'

export default () => {
    return configureStore({
        reducer:{
            menu: menuReducer,
            settings: settingsReducer,
            authUser: authReducer,
            pagination: paginationReducer,
            merchantsData: merchantsDataReducer
        }
    })
}
